import React, { useEffect, useState } from 'react';
import GoBackButton from '../content/common/GoBackButton';
// import Activities from './Activities';
// import Messages from './Messages';
import { ImageBackground } from 'react-native';
import { useOverviewState, overviewAPI } from '../../context/overview';
import { useEnvState } from '../../context/env';
import { useAuthState } from '../../context/auth';
import { useCategoriesState } from '../../context/categories';
import { useTheme, Text, Box, Pressable, Circle, HStack, FlatList, useBreakpointValue } from 'native-base';
import { getImage } from '../utils/images';
import { clone } from '../utils/helpers';
import Activity from './Activity';
import { DEVICE_HEIGHT, NOTIFICATIONS_TABS, Z_INDEX, AVATAR_SIZE } from '../Constants';
import Filter from './Filter';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
const NotificationScreen = _ref => {
  let {
    navigation
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const carrotsImage = {
    uri: getImage('carrots')
  };
  const overviewState = useOverviewState();
  const {
    unreadActivityCount,
    unreadMessagesCount,
    unreadMessagesSentCount
  } = overviewState;
  const envState = useEnvState();
  const authState = useAuthState();
  const categoriesState = useCategoriesState();
  const [notifications, setNotifications] = useState([]);
  const [messages, setMessages] = useState([]);
  const [messagesSent, setMessagesSent] = useState([]);
  const [selected, setSelected] = useState('Activity');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    loadContents();
  }, [envState.base_url, authUserName, authState.api_key, selected, selectedFilter]);
  const loadContents = () => {
    if (envState.base_url && authUserName && authState.api_key && selected && selectedFilter) {
      getDisplayData();
      setRenderItem();
    }
  };
  const getDisplayData = async () => {
    const allowedTabNames = NOTIFICATIONS_TABS.map(tab => tab.name);
    if (!allowedTabNames.includes(selected)) {
      throw new Error('Invalid selected value');
    }

    // TODO: make all 3 api calls at once and manage rendered items with state/context

    if (selected === NOTIFICATIONS_TABS[0].name && selectedFilter) {
      let allProductCategories = [categoriesState.rootProductCategory, categoriesState.rootForumCategory, ...categoriesState.forumCategories].map(c => c.id).filter(c => c);
      const retrievedNotifications = await overviewAPI.getNotifications(envState.base_url, authUserName, authState.api_key, authState.moderator, envState.product, allProductCategories, selectedFilter.toLowerCase() // 'all', 'read', 'unread'
      );

      setNotifications(retrievedNotifications);
      return retrievedNotifications;
    }
    /*
    to be added later
       else if (selected === NOTIFICATIONS_TABS[1].name) {
     read messages from overview state
     } else if (selected === NOTIFICATIONS_TABS[2].name) {
     read messagesSent from overview state
     }
    */
  };

  const setRenderItem = () => {
    let data;
    if (selected === NOTIFICATIONS_TABS[0].name) {
      data = _ref2 => {
        let {
          item: notification
        } = _ref2;
        return /*#__PURE__*/React.createElement(Activity, {
          key: notification.id.toString(),
          activity: notification,
          navigation: navigation,
          updateNotifications: updateNotifications,
          selected: selected,
          loadContents: loadContents
        });
      };
    }
    /*
    to be added later
     else if (selected === NOTIFICATIONS_TABS[1].name) {
     data = <Message /> component
     } else if (selected === NOTIFICATIONS_TABS[2].name) {
     data = <MessagesSent /> component
     }
    */

    return data;
  };
  const renderItem = setRenderItem();
  const setTabsDisplay = tabItem => {
    const {
      name,
      isInUse
    } = tabItem;
    const isCurrentlySelected = name === selected;

    // only Activity will be displayed for now
    if (isInUse) {
      return /*#__PURE__*/React.createElement(Pressable, {
        onPress: () => setSelected(name)
      }, /*#__PURE__*/React.createElement(Box, {
        borderBottomColor: isCurrentlySelected ? colors.activity.border : '',
        borderBottomWidth: isCurrentlySelected ? '2' : '0',
        px: "4"
      }, /*#__PURE__*/React.createElement(HStack, {
        space: 1,
        py: "3"
      }, /*#__PURE__*/React.createElement(Text, {
        fontWeight: isCurrentlySelected ? 'bold' : '',
        color: colors.activity.text
      }, name), /*#__PURE__*/React.createElement(Circle, {
        bg: colors.activity.border,
        px: "2"
      }, /*#__PURE__*/React.createElement(Text, {
        color: colors.notification.icon
      }, unreadActivityCount)))));
    } else {
      return /*#__PURE__*/React.createElement(Box, {
        px: "4"
      });
    }
  };
  const updateNotifications = activityId => {
    const activitiesList = clone(notifications);
    for (let i = 0; i < activitiesList.length; i++) {
      if (activityId === activitiesList[i].id) {
        activitiesList[i].read = true;
        setNotifications(activitiesList);
        break;
      }
    }
  };

  // container width
  const width = useBreakpointValue({
    base: '100vw',
    lg: '70vw'
  });

  // flatlist height
  const height = useBreakpointValue({
    base: DEVICE_HEIGHT,
    lg: DEVICE_HEIGHT * 0.7
  });

  // flatlist margin bottom
  const marginBottom = useBreakpointValue({
    base: '12vh',
    lg: 0
  });
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    w: width,
    h: "16vh",
    mb: "16"
  }, /*#__PURE__*/React.createElement(ImageBackground, {
    source: carrotsImage,
    imageStyle: {
      opacity: 0.5
    },
    style: {
      height: '100%',
      borderTopRightRadius: 10,
      borderTopLeftRadius: 10
    }
  }, /*#__PURE__*/React.createElement(Box, {
    pt: "4",
    pl: "4"
  }, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: navigation
  })), /*#__PURE__*/React.createElement(Text, {
    fontSize: '2xl',
    color: colors.searchResult.header,
    fontWeight: "bold",
    pl: "4",
    pb: "4",
    style: {
      marginTop: 'auto'
    }
  }, "Inbox")), /*#__PURE__*/React.createElement(HStack, {
    space: 4
  }, NOTIFICATIONS_TABS.map(tab => setTabsDisplay(tab))), /*#__PURE__*/React.createElement(Filter, {
    selected: selected // 'Activity', 'Messages', 'Sent'
    ,
    selectedFilter: selectedFilter // 'All', 'Read', 'Unread'
    ,
    setSelectedFilter: setSelectedFilter,
    isFilterOpen: isFilterOpen,
    setIsFilterOpen: setIsFilterOpen
  })), /*#__PURE__*/React.createElement(Pressable, {
    w: "60px",
    h: "60px",
    position: "fixed",
    bottom: "13vh",
    right: "3.3vw",
    zIndex: Z_INDEX.top,
    bg: "#000",
    borderRadius: "50px",
    justifyContent: "center",
    alignItems: "center",
    onPress: () => navigation.navigate('SearchRecipient')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPaperPlane,
    size: AVATAR_SIZE,
    color: "#fff"
  })), /*#__PURE__*/React.createElement(Box, {
    w: width,
    h: height,
    mb: marginBottom
  }, !(notifications !== null && notifications !== void 0 && notifications.length) ? /*#__PURE__*/React.createElement(Text, {
    alignSelf: "center"
  }, "You're up to date!") : /*#__PURE__*/React.createElement(FlatList, {
    data: notifications,
    renderItem: renderItem,
    keyExtractor: notification => notification.id.toString()
  })));
};
export default NotificationScreen;

// initialLayout={{width: layout.width}}
//# sourceMappingURL=NotificationScreen.js.map